import {gsap} from 'gsap'
export const VideoInit = () => {

   
    function trackingVideo(player,url) {

      let percentageCheck = {
          25: false,
          50: false,
          75: false
        };

      player().on('play', function() {
        this.getVideoTitle().then(function(title) {
            document.dispatchEvent(new CustomEvent('PlayVideo', {detail: {url : url, title}}));
         });
      });
      player().on('pause', function() {
        this.getVideoTitle().then(function(title) {
            document.dispatchEvent(new CustomEvent('PauseVideo', {detail: {url : url, title}}));
         });
      });
      player().on('ended', function() {
         this.getVideoTitle().then(function(title) {
            document.dispatchEvent(new CustomEvent('EndedVideo', {detail: {url : url, title}}));
         });
      });
      player().on('timeupdate', function(e) {
        let progress = e.percent;
        if (!percentageCheck[25] && progress >= 0.25 && progress < 0.5) {
          percentageCheck[25] = true;
          this.getVideoTitle().then(function(title) {
            document.dispatchEvent(new CustomEvent('ProgressVideo', {detail: {url : url, title, percentage : 25}}));
          });
        }
        if (!percentageCheck[50] && progress >= 0.5 && progress < 0.75) {
          percentageCheck[50] = true;
          this.getVideoTitle().then(function(title) {
            document.dispatchEvent(new CustomEvent('ProgressVideo', {detail: {url : url, title, percentage : 50}}));
          });
        }
        if (!percentageCheck[75] && progress >= 0.75 && progress < 0.99) {
          percentageCheck[75] = true;
          this.getVideoTitle().then(function(title) {
            document.dispatchEvent(new CustomEvent('ProgressVideo', {detail: {url : url, title, percentage : 75}}));
          });
        }
      });
    }
    const services = {
    vimeo: () => import('./../services/vimeo')
  },
  helpers = {
    blockNativeScroll: () => import('./../helpers/block-native-scroll'),
    blockSmoothScroll: () => import('./../helpers/block-smooth-scroll')
  },
  animations = {
    toggleVideoOverlay: () => import('./../animations/toggle-video-overlay'),
    fadeTopNavigation: () => import('./../animations/header/fade-top-navigation'),
  },
  videoOverlay = document.querySelectorAll('.yacht__video-overlay'),
  videoOverlayContainer = document.querySelectorAll('.yacht__video-overlay__content'),
  videoInlineContainer = document.querySelectorAll('.video-inline-container'),
  
  videoOverlayClose = document.querySelectorAll('.overlay-btn--close'),
  vimeoVideosInline = document.querySelectorAll('.video-inline'),
  vimeoVideos = document.querySelectorAll('[data-vimeo]');

  async function initialize() {
    var player_Array = [];
    var player_Array_inline = [];
    var vimeoUrl_Array = [];
    let dataID,
      isOpen = false,
      videoInit = false;
      if(vimeoVideosInline) {
        for(const vimeoVideo of vimeoVideosInline) {
            dataID = vimeoVideo.getAttribute('data-id')
            var vimeoUrl = vimeoVideo.getAttribute('data-vimeo-inline');
            var player = null;
            if (player_Array_inline[dataID] == undefined) {
               await services.vimeo().then(module => {
                player = () => module.vimeoPlayer(videoInlineContainer[dataID], {
                  url: vimeoUrl,
                  autoplay: false,
                  width: 1920
                })
                player_Array_inline[dataID] = player;
                trackingVideo(player_Array_inline[dataID],vimeoUrl);
              })
            }
        }
      }
      if (vimeoVideos) {
        for(const vimeoVideo of vimeoVideos) {
          vimeoVideo.addEventListener('click', () => {
              dataID = vimeoVideo.getAttribute('data-id')
              var vimeoUrl = vimeoVideo.getAttribute('data-vimeo')
              if(vimeoUrl) {
                isOpen = true
                var player = null;
                animations.fadeTopNavigation().then(module => module.fadeTopNavigation(isOpen))
                helpers.blockSmoothScroll().then(module => module.blockSmoothScroll(isOpen))
                helpers.blockNativeScroll().then(module => module.blockNativeScroll(isOpen))

                 animations.toggleVideoOverlay().then(module => module.toggleVideoOverlay(isOpen, videoOverlay[dataID], () => {
                      if (player_Array[dataID] == undefined) {
                        services.vimeo().then(module => {
                          player = () => module.vimeoPlayer(videoOverlayContainer[dataID], {
                            url: vimeoUrl,
                            autoplay: false,
                            width: 1920
                          })
                          player_Array[dataID] = player;
                          trackingVideo(player_Array[dataID],vimeoUrl);
                          player_Array[dataID]().play()
                        })

                        videoInit = true
                      } else {
                        player_Array[dataID]().play()
                      }
                  }))
              }
            })
        }  
    }
    for(const videoClose of videoOverlayClose) {
      videoClose.addEventListener('click', () => {
          if (player_Array[dataID]) {
            player_Array[dataID]().pause()
            isOpen = false;
            videoInit = false;
            gsap.to(videoClose, {
              rotate: '+=180deg',
              duration: 1
            })
            animations.fadeTopNavigation().then(module => module.fadeTopNavigation(isOpen))
            animations.toggleVideoOverlay().then(module => module.toggleVideoOverlay(isOpen, videoOverlay[dataID]))
            helpers.blockSmoothScroll().then(module => module.blockSmoothScroll(isOpen))
            helpers.blockNativeScroll().then(module => module.blockNativeScroll(isOpen))
          }
        })
    }
        
  }
  initialize();
  
}

